module.exports = __webpack_public_path__ + "../resources/img/weather_sleet.a681435b.svg";